



























































































// @ is an alias to /src
import TitleBar from '@/modules/core/components/TitleBar.vue';
import { userApi } from '../user.api';
import { Component, Vue } from 'vue-property-decorator';
import { User } from '../user';
import { AccountActivationFormModel } from '../account-activation.form-model';

@Component({
  components: {
    TitleBar,
  },
})
export default class UserView extends Vue {
  public tokenValid = false;
  public user: User | null = null;
  public activationError: unknown = null;
  public formErrors: string[] = [];
  public checkingToken = true;
  public formModel = new AccountActivationFormModel();

  public get titleStack(): string[] {
    return ['Activation de compte'];
  }

  public get token(): string {
    return this.$route.query.token as string;
  }

  public async activate(): Promise<void> {
    this.activationError = null;

    try {
      await this.validateForm();
    } catch (_) {
      this.$buefy.snackbar.open({
        message: 'Veuillez corriger les erreurs et réessayer',
        type: 'is-danger',
      });

      return;
    }

    try {
      await userApi.activateAccount({
        token: this.token,
        password: this.formModel.password,
      });
      this.$buefy.snackbar.open({
        message: 'Compte activé avec succès',
        type: 'is-success',
      });
    } catch (e) {
      this.activationError = e;
    }

    if (!this.activationError) {
      try {
        await this.$router.replace('/');
      } catch (_) {}
    }
  }

  public async validateForm(): Promise<boolean> {
    await this.formModel.validate({ stopAtFirstError: false });

    if (!this.formModel.isValid) {
      throw new Error();
    }

    return true;
  }

  public async mounted(): Promise<void> {
    if (this.token) {
      this.checkingToken = true;

      try {
        this.tokenValid = await userApi.isActivationTokenValid(this.token);
      } catch (e) {}

      this.checkingToken = false;

      if (this.tokenValid) {
        this.user = await userApi.getUserByPasswordToken(this.token);
      }
    }
  }
}
